import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";
import moment from "moment";

const ScheduleTime = (props) => {
  return (
    <div className="timer-popup">
      {/* Date Picker */}
      <DatePicker
        selected={props.startDate}
        onChange={(date) => {
          props.setStartDate(date);
          props.setDate2(moment(date).format("YYYY-MM-DD"));
        }}
        inline
        minDate={new Date()}
        speekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />

      <div className="publish-row">
        <p>Publish at</p>
        <DatePicker
          selected={props.timeshow}
          dropdownMode="select"
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={30}
          dateFormat="h:mm aa"
          autoComplete="off"
          onChange={(value) => {
            props.setTime(value);
            props.setTime2(moment(value).format("HH:mm"));
          }}
          className="react-time-input"
          calendarClassName="react-time-picker"
          popperClassName="react-time-propper"
        />
        {/* <TimePicker
              showSecond={false}
              defaultValue={now}
              className="xxx"
              onChange={(time) => {
              }}
              format={format}
              use12Hours
              inputReadOnly
            /> */}
      </div>
      <p hidden={!props?.startFutureError} className="error-message">
        Select future time
      </p>
      <div className="schedule-btn-row">
        <button
          className="schedule-btn"
          onClick={() => {
            props.publishLaterClickHandler();
          }}
        >
          Schedule
        </button>
      </div>
    </div>
  );
};

export default ScheduleTime;
